import React from 'react';
import { styled } from '@linaria/react';
import { POLICY_URL, PRIVACY_URL, SUPPORT_URL } from '~/constants';
const PolicyLinks = () => <LinkWrapper>
    <a href={POLICY_URL} target="_blank">
      Quy chế hoạt động sàn
    </a>
    <span>&#8226;</span>
    <a href={PRIVACY_URL} target="_blank">
      Chính sách bảo mật
    </a>
    <span>&#8226;</span>
    <a href={SUPPORT_URL} target="_blank">
      Liên hệ hỗ trợ
    </a>
  </LinkWrapper>;
const LinkWrapper = /*#__PURE__*/styled('div')({
  name: "LinkWrapper",
  class: "l1j2xuoh",
  propsAsIs: false
});
export default PolicyLinks;

require("./PolicyLinks.linaria.module.css!=!../../../../node_modules/.pnpm/@linaria+webpack5-loader@4.1.17_webpack@5.83.1/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./PolicyLinks.tsx");